export default "__VITE_ASSET__pbZokCOH__"